export const HERBALIFE_STORE_URL = "https://shellyperreault.goherbalife.com";
export const HERBALIFE_ACCOUNT_URL = "https://accounts.myherbalife.com/Account/Create";

export const PRODUCTS = [
  {
    id: "liftoff",
    name: "LIFTOFF",
    flavor: "❤️ Favorite: Pomegranate",
    fav: true,
    description: "My go-to fizzy drink tablet — pomegranate is the flavor I always come back to.",
    button: "SHOP LIFTOFF",
    url: "https://shellyperreault.herbalife.com/en-us/u/search?q=Liftoff&tab=Products",
    img: "/liftoff-box.jpeg",
    contain: true,
  },
  {
    id: "memoryarmor",
    name: "MEMORYARMOR",
    flavor: "30 ct — ❤️ Favorite",
    fav: true,
    description: "A simple once-a-day capsule that's part of my daily wellness shelf.",
    button: "SHOP MEMORYARMOR",
    url: "https://shellyperreault.herbalife.com/en-us/u/products/brain-health-30-capsules-101k",
    img: "/memoryarmor.jpeg",
    contain: true,
  },
  {
    id: "protein-shake",
    name: "PROTEIN SHAKE",
    flavor: "❤️ Favorite: Cookies & Cream",
    fav: true,
    description: "The classic shake that honestly tastes like dessert in a glass.",
    button: "SHOP PROTEIN SHAKE",
    url: "https://shellyperreault.herbalife.com/en-us/u/search?q=Cookies%20and%20cream&tab=Products",
    img: "/protein-shake.jpeg",
    contain: true,
  },
  {
    id: "multivitamins",
    name: "MULTIVITAMINS",
    flavor: "90 count — ❤️ Favorite",
    fav: true,
    description: "An everyday multivitamin that rounds out my routine.",
    button: "SHOP MULTIVITAMINS",
    url: "https://shellyperreault.herbalife.com/en-us/u/search?q=Multivitamin&tab=Products",
    img: "/multivitamins.jpeg",
    contain: true,
  },
  {
    id: "beverage-mix",
    name: "BEVERAGE MIX",
    flavor: "❤️ Favorite: Mango / Berry",
    fav: true,
    description: "Light, fruity and refreshing — mango and berry are my two favorites.",
    button: "SHOP BEVERAGE MIX",
    url: "https://shellyperreault.herbalife.com/en-us/u/search?q=Berage%20mix&tab=Products",
    img: "/beverage-mix.jpeg",
    contain: true,
  },
  {
    id: "aloe",
    name: "ALOE",
    flavor: "Pint Size — ❤️ Favorite: Cranberry",
    fav: true,
    description: "A soothing aloe drink — cranberry is the flavor I always keep stocked.",
    button: "SHOP ALOE",
    url: "https://shellyperreault.herbalife.com/en-us/u/search?q=Alo&tab=Products",
    img: "/aloe-bottle.jpeg",
    contain: true,
  },
  {
    id: "teas",
    name: "HERBALIFE TEAS",
    flavor: "❤️ Favorites: Pomegranate & Lemon",
    fav: true,
    description: "My afternoon ritual — pomegranate and lemon are tied for first place.",
    button: "SHOP TEAS",
    url: "https://shellyperreault.herbalife.com/en-us/u/search?q=TeAs&tab=Products",
    img: "/herbal-tea.jpeg",
    contain: true,
  },
  {
    id: "protein-coffee",
    name: "PROTEIN COFFEE",
    flavor: "❤️ Favorites: House Blend & Mocha",
    fav: true,
    description: "Coffee with a little extra — house blend on weekdays, mocha on weekends.",
    button: "SHOP PROTEIN COFFEE",
    url: "https://shellyperreault.herbalife.com/en-us/u/search?q=Progein%20coffee&tab=Products",
    img: "/protein-coffee.jpeg",
    contain: true,
  },
  {
    id: "collagen",
    name: "COLLAGEN",
    flavor: "❤️ Favorite: Strawberry Lemonade",
    fav: true,
    description: "My ride-or-die SKIN Collagen Beauty Booster — one scoop, tastes like summer.",
    button: "SHOP COLLAGEN",
    url: "https://shellyperreault.herbalife.com/en-us/u/search?q=Colagen&tab=Products",
    img: "/collagen.jpeg",
    contain: true,
  },
  {
    id: "prolessa",
    name: "PROLESSA",
    flavor: "The waist trainer",
    fav: false,
    description: "My famous Donut Shot powder — I mix it into my routine and it's a favorite for a reason.",
    button: "SHOP PROLESSA",
    url: "https://shellyperreault.herbalife.com/en-us/u/search?q=Prolessa&tab=Products",
    img: "/prolessa.jpeg",
    contain: true,
  },
];
